import { Link } from "react-router-dom";
import BaseCom from "../../../components/BaseCom";
import { withParamsAndNavigate } from "../../../components/WithParamsAndNavigate";
import Icon from "../../../components/Icon";
import L from "../../../components/Lang";

class Admin extends BaseCom {
    render() {
        return (
            <div className="container-fluid">
                <h1><L>Administration</L></h1>
                <ul className="list-group">
                    <li className="list-group-item"><Link to="api-client"><Icon icon="faTape" /> <L>API Client Manager</L></Link></li>
                    <li className="list-group-item"><Link to="healthcheck"><Icon icon="faHeart" /> <L>Health Check</L></Link></li>
                    <li className="list-group-item"><Link to="user"><Icon icon="faUsers" /> <L>User Manager</L></Link></li>
                </ul>
            </div>
        );
    }
}

export default withParamsAndNavigate(Admin);